import React, { useContext } from 'react';

import Skeleton from 'components/common/utils/Skeleton';

import { DetailedProjectContext } from '../DetailedProjectContext/DetailedProjectContext';
import DetailedProjectNavigation from '../DetailedProjectNavigation';
import { useWindowWidth } from '../hooks';
import ProjectDropdown from '../ProjectDropdown';
import CollectionSection from './CollectionSection';
import styles from './ProjectCollection.module.scss';

/**
 * Вкладка "Ход взыскания" — что департамент взыскания сделал и планирует по проекту.
 *
 * Данные грузит DetailedProject и кладёт в DetailedProjectContext: навигации надо решить,
 * показывать ли вкладку, до того как её откроют. Поэтому здесь нет ни запроса, ни
 * обработки ошибок — только отображение.
 */
const ProjectCollection = () => {
  const { collection, collectionLoading } = useContext(DetailedProjectContext);
  const isMobile = useWindowWidth();

  const items = collection ?? [];

  const content = collectionLoading ? (
    <Skeleton height={320} />
  ) : items.length === 0 ? (
    // В обычной навигации сюда не попасть — вкладка скрыта. Но на прямой переход по
    // ссылке нужно ответить текстом, а не пустым экраном.
    <p className={styles.empty}>Данных по взысканию по этому проекту пока нет.</p>
  ) : (
    items.map((item) => (
      <CollectionSection key={item.uuid} item={item} showHeading={items.length > 1} />
    ))
  );

  return (
    <div className={styles.container}>
      {isMobile ? (
        <ProjectDropdown header="Ход взыскания">{content}</ProjectDropdown>
      ) : (
        <>
          <div className="detailed-project__header">
            <DetailedProjectNavigation />
          </div>
          <div className="detailed-project__content">{content}</div>
        </>
      )}
    </div>
  );
};

export default ProjectCollection;
